"use client"

import {
  Container,
  Hero,
  TitleWithLine,
  useIsDesktop
} from "ui"
import { extractProperty } from "utils"

import { GetStockDataResponse } from "lib/api"
import ContactInfo from "./ContactInfo"
import HeroStrockWrap from "./HeroStrockWrap"

type Props = {
  data: any
  meetings?: boolean
  stockData?: GetStockDataResponse
  maxStockData?: GetStockDataResponse
  locale: string
}

function HeroWrapper({ data, meetings, stockData, maxStockData, locale }: Props) {
  const isDesktop = useIsDesktop()
  const en = locale === "en"
  const banner = extractProperty(data, "banner")
  const contactInfo = extractProperty(data, "contactInfo")
  const desktopImage = extractProperty(banner[0], "desktopImage")
  const mobileImage = extractProperty(banner[0], "mobileImage")
  const data_for_hero = {
    __typename: "BasicBlockListItem",
    blockType: "sliderBlock",
    properties: [
      {
        __typename: "BasicProperty",
        propertyName: "slides",
        propertyValue: {
          __typename: "BasicBlockListModel",
          valueType: "BasicBlockListModel",
          blocks: [
            {
              __typename: "BasicBlockListItem",
              blockType: "slideBlock",
              properties: [
                {
                  __typename: "BasicProperty",
                  propertyName: "deskopImage",
                  propertyValue: {
                    __typename: "BasicMediaPicker",
                    valueType: "BasicMediaPicker",
                    mediaItems: [
                      {
                        __typename: "BasicMediaPickerItem",
                        id: 2122,
                        url: desktopImage,
                      },
                    ],
                  },
                },
                {
                  __typename: "BasicProperty",
                  propertyName: "mobileImage",
                  propertyValue: {
                    __typename: "BasicMediaPicker",
                    valueType: "BasicMediaPicker",
                    mediaItems: [
                      {
                        __typename: "BasicMediaPickerItem",
                        id: 2123,
                        url: mobileImage,
                      },
                    ],
                  },
                },
              ],
            },
          ],
        },
      },
    ],
  }

  return (
    <>
      <Hero
        attachments={<ContactInfo data={contactInfo[0]} />}
        data={data_for_hero}
      >
        <HeroStrockWrap stockData={stockData} maxStockData={maxStockData} en={en} />
      </Hero>
      {meetings && (
        <Container>
          <TitleWithLine
            title="אסיפות כלליות"
            titleColor="black"
            largeDesktopFontSize={64}
            largeDesktopLineHeight="76.8px"
            mobileLineHeight="50.4px"
            mobileTitleFontSize={36}
            titleFontSize={42}
            desktopLineHeight="50.4px"
            marginBottom={40}
            marginTop={isDesktop ? 6 : 40}
          />
        </Container>
      )}
    </>
  )
}

export default HeroWrapper
